<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>签到主题管理</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="ID">
              <el-input v-model.number="item.id" style="width: 100px;" placeholder="ID" />
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model="item.name" style="width: 150px;" placeholder="主题名称" />
            </el-form-item>
            <el-form-item label="类型">
              <el-input v-model="item.type" style="width: 150px;" placeholder="主题类型" />
            </el-form-item>
            <el-form-item label="切换日期">
              <el-date-picker
                v-model="item.change_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期时间"
              />
            </el-form-item>
            <el-form-item label="当前主题">
              <el-switch v-model="item.selected" @change="(v)=>{return changeTemplate(v, item.type)}" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:signInSkin:del']" type="danger" @click="del(index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:signInSkin:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:signInSkin:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActiveNameCfg, updateActiveNameCfg } from '@/api/config/active-name-cfg'
import { updateCoinDozerCfg } from '@/api/config/sys-cfg'
export default {
  name: 'SignInLevel',
  data() {
    return {
      name: 'signIn',
      nowSkin: '',
      formData: [
        {
          'id': 1,
          'name': '',
          'type': '',
          'change_date': '',
          'selected': true
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.name === '') {
          this.msgError('名称不能为空')
          return
        }

        if (_data.type === '') {
          this.msgError('类型不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateActiveNameCfg({ name: this.name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActiveNameCfg().then(res => {
        if (res.code === 200) {
          for (const i in res.data.sign) {
            res.data.sign[i].selected = false
            if (res.data.sign[i].type === res.data.signTemplate) {
              res.data.sign[i].selected = true
            }
          }
          this.formData = res.data.sign
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      const id = parseInt(Object.keys(this.formData).length) + 2
      const key = id.toString()
      // this.formData.push({
      //   'id': id,
      //   'name': '',
      //   'type': '',
      //   'change_date': ''
      // })
      // console.log('this.formData -before', this.formData)
      // console.log('len', key)
      this.$set(this.formData, key, {
        'id': id,
        'name': '',
        'type': '',
        'change_date': ''
      })

      // console.log('this.formData', this.formData)
    },
    del(index) {
      // delete this.formData[index]
      // console.log(this.formData)
      this.$delete(this.formData, index)
      // this.formData = this.formData.filter((res, key) => {
      //   return index !== key
      // })
    },
    changeTemplate(v, changeVal) {
      updateCoinDozerCfg({ name: 'signInDir', data: changeVal }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
